import React, { useEffect, useState } from "react";
import { useLoading } from "../Loading";
import { useAuth } from "../../contexts/authContext";
import db from "../../firebase/firebaseConfig";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { CFormLabel, CCol, CForm, CFormTextarea, CFormSelect } from '@coreui/react'
import { getAuth, updateProfile } from "firebase/auth";
import { useNavigate } from "react-router-dom";

function Profile() {
    const { setLoading } = useLoading();
    const { currentUser } = useAuth();
    const auth = getAuth();
    const user = auth.currentUser;
    const navigate = useNavigate();
    const [adopterData, setAdopterData] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [ready, getReady] = useState(false);
    const malaysiaStates = [
        "Johor",
        "Kedah",
        "Kelantan",
        "Malacca",
        "Negeri Sembilan",
        "Pahang",
        "Perak",
        "Perlis",
        "Penang",
        "Sabah",
        "Sarawak",
        "Selangor",
        "Terengganu",
        "Kuala Lumpur",
    ];
    useEffect(() => {
        setLoading(true);
    }, [])



    useEffect(() => {

        if (!currentUser) {
            navigate('/');
            return;
        }

        const fetchAdopterInfo = async () => {
            const adopterRef = doc(db, "Adopters", currentUser.uid);
            const adopterSnap = await getDoc(adopterRef);
            console.log(adopterSnap);
            if (adopterSnap.exists()) {
                const adopterData = adopterSnap.data();
                setAdopterData(adopterData);
                setLoading(false);
                getReady(true);
            }
        }
        fetchAdopterInfo();

    }, [currentUser]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setAdopterData((preData) => ({
            ...preData,
            [id]: value
        }));
    };

    const handleEdit = () => {
        setIsEditing(true);
    }

    const handleSave = async () => {

        if (adopterData.name && (/^\d{6}-\d{2}-\d{4}$/.test(adopterData.icNumber)) && adopterData?.postcode?.length === 5
            && adopterData.age >= 12 && adopterData.age <= 100 && (/^\+601\d-\d{7,8}$/.test(adopterData.phoneNumber)) && adopterData.address
            && adopterData.city && adopterData.state) {
            setLoading(true);
            try {
                const adopterRef = doc(db, "Adopters", currentUser.uid);
                await updateProfile(user, {
                    displayName: adopterData.name,
                });
                await updateDoc(adopterRef, adopterData);
                window.location.reload();
                alert("Profile Updated");
                setIsEditing(false);
                setLoading(false);
            }
            catch (error) {
                console.log(error);
                setLoading(false);
            }
        }
    }

    return (
        <div className="profileContainer">
            <h1>My Profile</h1>
            {ready &&
                <>
                    <div className="profileDetails">
                        <CForm className="row g-3" >
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputName" className="formLabel">Name</CFormLabel>
                                <CFormTextarea id="name" value={adopterData.name} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} rows="1" />
                                {!adopterData.name && (
                                    <p className="errorMessage">Name cannot be empty</p>
                                )}
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputIC" className="formLabel">IC Number</CFormLabel>
                                <CFormTextarea id="icNumber" value={adopterData.icNumber} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} rows="1"
                                />
                                {(!adopterData.icNumber || !(/^\d{6}-\d{2}-\d{4}$/.test(adopterData.icNumber))) && (
                                    <p className="errorMessage">IC Number must be in the format xxxxxx-xx-xxxx</p>
                                )}
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputAge" className="formLabel">Age</CFormLabel>
                                <CFormTextarea id="age" type="number" value={adopterData.age} maxLength={2}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                                        setAdopterData(prev => ({ ...prev, age: value }));
                                    }}
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} required rows="1" />
                                {(!adopterData.age || (adopterData.age < 12 || adopterData.age > 100)) && (
                                    <p className="errorMessage">Age must between 12 and 100</p>
                                )}
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputEmail" className="formLabel">Email</CFormLabel>
                                <CFormTextarea type="email" id="inputEmail" value={adopterData.email} onChange={handleChange}
                                    disabled readOnly className={isEditing ? "edit" : "no-border"} rows="1"
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputGender" className="formLabel">Gender</CFormLabel>
                                <CFormSelect id="gender" value={adopterData.gender} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} >
                                    <option value="Female">Female</option>
                                    <option value="Male">Male</option>
                                </CFormSelect>
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputTelephone" className="formLabel">Telephone</CFormLabel>
                                <CFormTextarea id="phoneNumber" value={adopterData.phoneNumber} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} rows="1" />
                                {(!adopterData.phoneNumber || !(/^\+601\d-\d{7,8}$/.test(adopterData.phoneNumber))) && (
                                    <p className="errorMessage">Phone Number must be in the format +601x-xxxxxxx</p>
                                )}
                            </CCol>

                            <CCol md={6}>
                                <CFormLabel htmlFor="inputAddress" className="formLabel">Address</CFormLabel>
                                <CFormTextarea id="address" value={adopterData.address} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} rows="2" />
                                {!adopterData.address && (
                                    <p className="errorMessage">Address cannot be empty</p>
                                )}
                            </CCol>

                            <CCol md={6}>
                                <CFormLabel htmlFor="inputPostcode" className="formLabel">Postcode</CFormLabel>
                                <CFormTextarea id="postcode" value={adopterData.postcode} rows="1"
                                    maxLength={5} required
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                                        if (/^\d{0,5}$/.test(value)) {
                                            setAdopterData(prev => ({ ...prev, postcode: value }));
                                        }
                                    }}
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} />
                                {(!adopterData.postcode || (adopterData?.postcode?.length < 5 && adopterData?.postcode.length > 0)) && (
                                    <p className="errorMessage">Postcode must be exactly 5 digits</p>
                                )}
                            </CCol>

                            <CCol md={6}>
                                <CFormLabel htmlFor="inputCity" className="formLabel">City</CFormLabel>
                                <CFormTextarea id="city" value={adopterData.city} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"} rows="1" />
                                {!adopterData.city && (
                                    <p className="errorMessage">City cannot be empty</p>
                                )}
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="inputState" className="formLabel">State</CFormLabel>
                                <CFormSelect id="state" value={adopterData.state} onChange={handleChange} required
                                    readOnly={!isEditing} className={isEditing ? "edit" : "no-border"}>
                                    {malaysiaStates.map(state => (
                                        <option key={state} value={state}>{state}</option>
                                    ))}
                                </CFormSelect>
                            </CCol>
                        </CForm>
                    </div>

                    {isEditing ? <button onClick={handleSave} className="profileBtn">Save</button>
                        : <button onClick={handleEdit} className="profileBtn">Edit</button>}
                </>
            }
        </div>
    );
}



export default Profile;